// Module
var code = `{{#.width}}width:{{.width}}px;{{/}}
{{#.height}}height:{{.height}}px;{{/}}
{{#if top !== undefined && top !== null}}
    top: {{top}}px;
{{/if}}
{{#.bottom}}bottom:{{.bottom}}px;{{/}}
{{#.left}}left:{{.left}}px;{{/}}
{{#.right}}right:{{.right}}px;{{/}}
{{#.margin}}margin:{{.margin}}px;{{/}}
{{^.visible}}display:none;{{/}}`;
// Exports
export default code;